import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { AltriSoggettiFormComponent } from './dialogs/form/form.component';
import { AltriSoggettiRoutingModule } from './altri-soggetti-routing.module';
import { AltriSoggettiComponent } from './altri-soggetti.component';
import { RicercaGenericaAnagraficheModule } from '../ricerca-generica-anagrafiche/ricerca-generica-anagrafiche.module';
import { SearchComponent } from './search/search.component';



@NgModule({
  declarations: [AltriSoggettiComponent, AltriSoggettiFormComponent, SearchComponent],
  imports: [
    CommonModule,
    AltriSoggettiRoutingModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFormControlsModule,
    ResourcefulIndexModule,
    RicercaGenericaAnagraficheModule,

  ]
})
export class AltriSoggettiModule { }
